import { createContext, useCallback, useContext, useState } from 'react'

import ManageEnterpriseInviteModal from 'src/features/enterprise-membership/modals/manage-enterprise-invite-modal'

interface NotificationModalsState {
  enterpriseInvite: {
    open: boolean
    invitationId: string | number | null
  }
}

interface NotificationModalsContextValue {
  openEnterpriseInviteModal: (invitationId: string | number) => void
  closeEnterpriseInviteModal: () => void
  showNotificationModal: boolean
  setShowNotificationModal: (showNotificationModal: boolean) => void
}

const NotificationModalsContext = createContext<NotificationModalsContextValue | null>(null)

export function useNotificationModals() {
  const ctx = useContext(NotificationModalsContext)
  if (!ctx) throw new Error('useNotificationModals must be used within NotificationModalsProvider')
  return ctx
}

export function NotificationModalsProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<NotificationModalsState>({
    enterpriseInvite: { open: false, invitationId: null },
  })
  const [showNotificationModal, setShowNotificationModal] = useState<boolean>(false)

  const openEnterpriseInviteModal = useCallback((invitationId: string | number) => {
    setShowNotificationModal(false)
    setState((prev) => ({
      ...prev,
      enterpriseInvite: { open: true, invitationId },
    }))
  }, [])

  const closeEnterpriseInviteModal = useCallback(() => {
    setState((prev) => ({
      ...prev,
      enterpriseInvite: { open: false, invitationId: null },
    }))
  }, [])

  return (
    <NotificationModalsContext.Provider
      value={{ openEnterpriseInviteModal, closeEnterpriseInviteModal, showNotificationModal, setShowNotificationModal }}
    >
      {children}
      {state.enterpriseInvite.invitationId != null && (
        <ManageEnterpriseInviteModal
          open={state.enterpriseInvite.open}
          onClose={closeEnterpriseInviteModal}
          invitationId={state.enterpriseInvite.invitationId}
        />
      )}
    </NotificationModalsContext.Provider>
  )
}
